// @ts-nocheck
/* eslint-disable */
export const outlineAddIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M4 7.5h8c.273 0 .5.227.5.5s-.227.5-.5.5H4a.504.504 0 0 1-.5-.5c0-.273.227-.5.5-.5"/><path d="M8 3.5c.273 0 .5.227.5.5v8c0 .273-.227.5-.5.5a.504.504 0 0 1-.5-.5V4c0-.273.227-.5.5-.5"/></svg>`,
    name: 'outline-add' as const
};